import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { NameSurname } from "./contactlistCol";

import { Box, Dialog, DialogTitle, DialogContent, IconButton, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import GlobalStyles from "@mui/material/GlobalStyles";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import axios from 'axios';
import jsPDF from "jspdf";
import "jspdf-autotable";


import Dropzone from 'react-dropzone-uploader';
import { Base64 } from 'js-base64';
import moment from "moment";

import {
  getNe as onGetNe,
  addNe as onAddNe,
  updateNe as onUpdateNe,
  deleteNe as onDeleteNe,
} from "store/contacts/actions";
import { isEmpty } from "lodash";

const inputGlobalStyles = (
  <GlobalStyles
    styles={{
      ".ck.ck-balloon-panel": {
        zIndex: "1400 !important", // Put a higher value that your MUI Dialog (generaly 1300)
      },
    }}
  />
);

//redux
import { useSelector, useDispatch } from "react-redux";

const ContactsList = props => {
  const tableRef = useRef(null);

  //meta title
  document.title = "Egzersiz Kategori | Lusi ADMIN PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();
  const [getFileName, setFileName] = useState(null);




  function uploadAdapter(loader) {
    return {
      upload: () => {
        return new Promise(async (resolve, reject) => {
          try {
            const file = await loader.file; // loader.file bir Promise nesnesi döndürür
  
            // Burada file değişkeni Promise'ın çözüldüğü (fulfilled) durumda, yani File nesnesini içerir
            const body = new FormData();
            body.append('dataFile', file);
            console.log("file1c2313",file);
  
            try {
              const response = await axios.request({
                method: "POST",
                url: `https://monoadmin.stechomeyazilim.info:8081/uploadfile`,
                data: body, // axios'ta "data" kullanın, "body" değil
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              });
  
              resolve({
                default: `https://monoadmin.stechomeyazilim.info:8335/${response.data.file.filename}`
              });
            } catch (error) {
              // Hata oluştuğunda throw ile hata fırlatın
              throw error;
            }
  
            // File nesnesini kullanarak istediğiniz işlemleri yapabilirsiniz
          } catch (error) {
            reject(error);
          }
        });
      },
      abort: () => {}
    };
  }
  
  

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: (contactEdit && contactEdit.categoryTitle) || "",
      categoryTitle_eng: (contactEdit && contactEdit.categoryTitle_eng) || "", // Eklendi
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Başlığı Giriniz"),
      categoryTitle_eng: Yup.string().required("English Title is required"), // Eklendi
    }),
  onSubmit: values => {
  const payload = {
    categoryTitle: values.title,
    categoryTitle_eng: values.categoryTitle_eng,
    image: getFileName,
    image_eng: getFileNameEng || getFileName, // Eğer İngilizce seçilmemişse Türkçesini kullan
  };

  if (isEdit) {
    dispatch(onUpdateNe({ ID: contactEdit.ID, ...payload }));
  } else {
    dispatch(onAddNe(payload));
  }
  toggle();
},
  });
  
  const { users } = useSelector(state => ({
    users: state.contacts.ne,
  }));

  const [userList, setUserList] = useState([]);
  const [modal, setModal] = useState(false);
const [getFileNameEng, setFileNameEng] = useState(null);

  const [isEdit, setIsEdit] = useState(false);


  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
      {
        Header: "Foto",
        // accessor: "name",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => (
          <>
            {!cellProps.image ? (
              <div className="avatar-xs">
                {cellProps.categoryTitle != null ? <span className="avatar-title rounded-circle">
                  {cellProps.categoryTitle.charAt(0)}
                </span> : null}
              </div>
            ) : (
              <div>
                <img
                  className="rounded-circle avatar-xs"
                  src={'https://monoadmin.stechomeyazilim.info:8335/' + cellProps.image}
                  alt=""
                />
              </div>
            )}
          </>
        ),
      },
      {
        Header: "Başlık",
        accessor: "categoryTitle",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },
      {
        Header: "Başlık (EN)",
        accessor: "categoryTitle_eng",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },
      {
        Header: "İşlemler",
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">


              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  const userData = cellProps.row.original;
                  handleUserClick(userData);
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const userData = cellProps.row.original;
                  onClickDelete(userData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );


  useEffect(() => {
    if (users && !users.length) {
      dispatch(onGetNe());
      setIsEdit(false);
    }
  }, [dispatch, users]);

  useEffect(() => {
    setContact(users);
    // setIsEdit(false);
  }, [users]);



  useEffect(() => {
    if (!isEmpty(users) && !!isEdit) {
      setContact(users);
    }
  }, [users]);

  const toggle = () => {
    setModal(!modal);
  };

// Mevcut state'lerin yanına ekleyin

// İngilizce görsel yükleme durumunu takip eden fonksiyon
const handleChangeStatusEng = ({ xhr }) => {
  if (xhr) {
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        const result = JSON.parse(xhr.response);
        setFileNameEng(result.file.filename);
      }
    }
  }
};

// handleUserClick fonksiyonunda mevcut değeri yükleyin
const handleUserClick = (arg) => {
  const user = arg;
  setEditContact(user);
  setFileName(user.image);
  setFileNameEng(user.image_eng); // İngilizce görseli yükle
  setIsEdit(true);
  toggle();
};



  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = users => {
    setContact(users);
    setDeleteModal(true);
  };

  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteNe(contact.ID));
    }
    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleUserClicks = () => {
    setUserList("");
    setIsEdit(false);
    toggle();
  };

 
  const Preview = ({ meta }) => {
    const { name, percent, status, previewUrl } = meta;
    return (
      <div className="preview-box">
        <img src={previewUrl} /> <span className="name">{name}</span> - <span className="status">{status == "done" ? "Başarıyla Yüklendi" : "Yükleniyor"}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span>}
      </div>
    )
  }


  const getUploadParams = ({ file }) => {
    const body = new FormData();
    body.append('dataFile', file);
    return { url: 'https://monoadmin.stechomeyazilim.info:8081/uploadfile', body }
  }



  const handleChangeStatus = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response);
          setFileName(result.file.filename)

        }
      }
    }
  }



  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="Egzersiz Kategori Listesi" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>


                  <TableContainer
                    columns={columns}
                    data={users}
                    ref={tableRef}
                    isGlobalFilter={true}
                    isAddActuel={true}
                    handleOrderClicks={handleUserClicks}
                    customPageSize={10}
                    className="custom-header-css"
                  />

                  <Dialog  open={modal} onClose={toggle} disableEnforceFocus maxWidth="md" fullWidth>
<DialogTitle sx={{ m: 0, p: 2 }}>
        <Typography variant="h6">Düzenle</Typography>
        <IconButton
          aria-label="close"
          onClick={toggle}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
<Box
      sx={{
        ".ck-editor__editable_inline": {
          height: "200px",
          border: (theme) =>
            theme.palette.mode === "light"
              ? "1px solid rgba(0, 0, 0, 0.20) !important"
              : "1px solid rgba(200, 200, 200, 0.25) !important",
          borderTop: "1px !important",
        },
      }}
    >
      {inputGlobalStyles}  

                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>

                       
                          {/* Mevcut Türkçe Başlık */}
<div className="mb-3">
  <Label className="form-label">Başlık (TR)</Label>
  <Input
    name="title"
    type="text"
    placeholder="Kategori Başlığını Giriniz"
    onChange={validation.handleChange}
    onBlur={validation.handleBlur}
    value={validation.values.title || ""}
    invalid={validation.touched.title && validation.errors.title ? true : false}
  />
  {validation.touched.title && validation.errors.title ? (
    <FormFeedback type="invalid">{validation.errors.title}</FormFeedback>
  ) : null}
</div>

{/* YENİ: İngilizce Başlık */}
<div className="mb-3">
  <Label className="form-label">Başlık (EN)</Label>
  <Input
    name="categoryTitle_eng"
    type="text"
    placeholder="Enter English Category Title"
    onChange={validation.handleChange}
    onBlur={validation.handleBlur}
    value={validation.values.categoryTitle_eng || ""}
    invalid={validation.touched.categoryTitle_eng && validation.errors.categoryTitle_eng ? true : false}
  />
  {validation.touched.categoryTitle_eng && validation.errors.categoryTitle_eng ? (
    <FormFeedback type="invalid">{validation.errors.categoryTitle_eng}</FormFeedback>
  ) : null}
</div>


<Row>
  <Col md={6}>
    {/* TÜRKÇE GÖRSEL */}
    <div className="mb-3">
      <Label htmlFor="resume">Görsel (TR)</Label>
      <Dropzone
        getUploadParams={getUploadParams}
        onChangeStatus={handleChangeStatus}
        maxFiles={1}
        accept="image/*"
        styles={{ dropzone: { minHeight: 100 } }}
      />
      {getFileName && (
        <img src={'https://monoadmin.stechomeyazilim.info:8335/' + getFileName} alt="" className="avatar-xl mt-2" />
      )}
    </div>
  </Col>

  <Col md={6}>
    {/* İNGİLİZCE GÖRSEL */}
    <div className="mb-3">
      <Label htmlFor="resume" className="text-primary">Görsel (EN)</Label>
      <Dropzone
        getUploadParams={getUploadParams}
        onChangeStatus={handleChangeStatusEng}
        maxFiles={1}
        accept="image/*"
        styles={{ 
          dropzone: { minHeight: 100, border: '1px dashed #3b5ed1' } 
        }}
      />
      {getFileNameEng && (
        <img src={'https://monoadmin.stechomeyazilim.info:8335/' + getFileNameEng} alt="" className="avatar-xl mt-2" />
      )}
    </div>
  </Col>
</Row>


                          </Col>
                        </Row>
                        <Row>



                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                   
                  </Box>
                  </DialogContent>
                  </Dialog>
                  
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);
